/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для формы авторизации
   */
  app.LoginFormView = app.CommonAuthFormView.extend({
    el: '#login-form',
    formName: 'login',
    formElement: '.field_input',
    
    events: {
      'click .button_blue': 'submit',
      'keypress .input': 'submitOnInputClick',
      'blur .input': 'validate',
      'click #forget_password': 'showResetPasswordRequestForm'
    },
    
    run: function () {
      app.CommonAuthFormView.prototype.run.apply(this);
      this.model = new app.LoginForm();
      this.childViews.entityInputFormView = new app.EntityInputFormView({ el: this.$el });
      this.childViews.passwordInputView = new app.PasswordInputView();
      var passwordResetRequestModel = new app.PasswordResetRequestForm();
      this.passwordResetRequestFormView = new app.PasswordResetRequestFormView({
        model: passwordResetRequestModel,
      });
      this.listenTo(this.passwordResetRequestFormView, 'go-to-login-form', this.render);
      this.passwordResetSuccessFormView = new app.PasswordResetSuccessFormView({
        model: passwordResetRequestModel,
      });
      this.listenTo(this.passwordResetSuccessFormView, 'go-to-login-form', this.render);
      this.listenTo(
        this.passwordResetRequestFormView,
        'password-reset-request-success',
        this.passwordResetSuccessFormView.render.bind(this.passwordResetSuccessFormView)
      );
      new app.ChoiceCountryView({el: this.$('.choice-country')}); // флаги стран
    },
    
    render: function () {
      this.$el.show();
      this.passwordResetRequestFormView.$el.hide();
      this.passwordResetSuccessFormView.$el.hide();
    },
  
    /**
     * Показывает форму восстановления пароля
     */
    showResetPasswordRequestForm: function () {
      this.$el.hide();
      this.passwordResetRequestFormView.render();
    },
  
    /**
     * Отправка формы по нажатию Enter на клавиатуре
     * @param e
     */
    submitOnInputClick: function (e) {
      if (e.keyCode === app.KEY_CODES.Enter) {
        this.submit(e);
      }
    },
  
    /**
     * Сбор данных формы для отправки
     * @return {*}
     */
    getData: function() {
      var attributes = app.CommonAuthFormView.prototype.getData.apply(this),
        inputType = this.$('#entity .input').attr('type');
      attributes.type = inputType === 'tel' ? 'phone' : 'email';
      return attributes;
    },
  
    /**
     * Заполнение ошибок
     * @param errors
     */
    fillErrors: function (errors) {
      app.CommonAuthFormView.prototype.fillErrors.call(this, errors);
      app.recommendationsEvents.trigger('errorLogin');
    }
  });
})();

}.call(window));